import { createContext, useContext, useState, ReactNode } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { BRAND_CONFIGS, DEFAULT_BRAND_ID } from '../../branding/brandRegistry';
import { BrandConfig } from '../../branding/brandConfig';

// wraps application with correct MUI and holds current brand ID

interface BrandContextType {
	brandId: string;
	brandConfig: BrandConfig;
	setBrandId: (brandId: string) => void;
}

const BrandContext = createContext<BrandContextType>({
	brandId: DEFAULT_BRAND_ID,
	brandConfig: BRAND_CONFIGS[DEFAULT_BRAND_ID],
	setBrandId: () => {},
});

export const useBrandContext = () => useContext(BrandContext);

export function BrandProvider({ children }: { children: ReactNode }) {
	const [brandId, setBrandId] = useState<string>(DEFAULT_BRAND_ID);
	const config = BRAND_CONFIGS[brandId] || BRAND_CONFIGS[DEFAULT_BRAND_ID];
	const value = {
		brandId,
		brandConfig: config,
		setBrandId,
	};

	return (
		<BrandContext.Provider value={value}>
			<ThemeProvider theme={value.brandConfig.theme}>
				<CssBaseline />
				{children}
			</ThemeProvider>
		</BrandContext.Provider>
	);
}
